// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const GeometryType = {
  Point: "Point",
  LineString: "LineString",
  Polygon: "Polygon",
  MultiPoint: "MultiPoint",
  MultiLineString: "MultiLineString",
  MultiPolygon: "MultiPolygon",
  GeometryCollection: "GeometryCollection",
} as const;
export type GeometryType = (typeof GeometryType)[keyof typeof GeometryType];

export function instanceOfGeometryType(value: any): boolean {
  for (const key in GeometryType) {
    if (Object.prototype.hasOwnProperty.call(GeometryType, key)) {
      if (GeometryType[key as keyof typeof GeometryType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function GeometryTypeFromJSON(json: any): GeometryType {
  return GeometryTypeFromJSONTyped(json, false);
}

export function GeometryTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeometryType {
  return json as GeometryType;
}

export function GeometryTypeToJSON(value?: GeometryType | null): any {
  return value as any;
}

export function GeometryTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): GeometryType {
  return value as GeometryType;
}
